<div style="height: 75vh">
  <div class="pad32">
    Click here to check Panelist and ExInfy details
    <a target="_blank" href="http://iscls3apps/vendor/aspx/panelistandexinfydetails.aspx" rel="noopener noreferrer"
      >http://iscls3apps/vendor/aspx/panelistandexinfydetails.aspx</a
    >
  </div>
  <div class="pad24" *ngIf="userRoleCode !== 'DBAD'">
    Click
    <a
      target="_blank"
      href="https://app.powerbi.com/reportEmbed?reportId=db12eb81-61b9-4ab4-87ec-2436d2e3f84f&autoAuth=true&ctid=63ce7d59-2f3e-42cd-a8cc-be764cff5eb6&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWVhc3QtYXNpYS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D"
      rel="noopener noreferrer"
      >here</a
    >
    to view All Event Report
  </div>
  <div class="pad24" *ngIf="userRoleCode !== 'DBAD'">
    Click
    <a
      target="_blank"
      href="https://app.powerbi.com/reportEmbed?reportId=5bfe8ee3-5587-4bad-88c8-701b0faf079a&autoAuth=true&ctid=63ce7d59-2f3e-42cd-a8cc-be764cff5eb6&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWVhc3QtYXNpYS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D"
      rel="noopener noreferrer"
      >here</a
    >
    to view All PCI Event Report
  </div>
  <div class="pad24" *ngIf="userRoleCode !== 'DBAD'">
    Click
    <a
      target="_blank"
      href="https://app.powerbi.com/reportEmbed?reportId=87c3b9a8-af11-493f-92ab-067ae06481a3&autoAuth=true&ctid=63ce7d59-2f3e-42cd-a8cc-be764cff5eb6&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWVhc3QtYXNpYS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D"
      rel="noopener noreferrer"
      >here</a
    >
    to view Event Master Report
  </div>
  <div class="pad24" *ngIf="userRoleCode !== 'DBAD'">
    Click
    <a
      target="_blank"
      href="https://app.powerbi.com/reportEmbed?reportId=1b7d17cc-fed5-4a4b-972d-21cf38f95907&autoAuth=true&ctid=63ce7d59-2f3e-42cd-a8cc-be764cff5eb6&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWVhc3QtYXNpYS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D"
      rel="noopener noreferrer"
      >here</a
    >
    to view Auto Scheduling Upload Report
  </div>
</div>
